function applyHoverEffects() {
  const buttons = document.querySelectorAll('.button');

  buttons.forEach(button => {
    if (button.querySelector('.text-wrapper')) return;

    let spanText = button.querySelector('span');
    let originalText = '';

    if (spanText && spanText.childNodes.length === 1 && spanText.childNodes[0].nodeType === Node.TEXT_NODE) {
      originalText = spanText.textContent.trim();
      if (!originalText) return;

      spanText.textContent = '';
      const wrapper = createAnimatedTextWrapper(originalText);
      spanText.appendChild(wrapper);
    } else {
      const textNode = Array.from(button.childNodes).find(node =>
        node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== ''
      );
      if (!textNode) return;

      originalText = textNode.textContent.trim();
      textNode.remove();

      const wrapper = createAnimatedTextWrapper(originalText);
      button.insertBefore(wrapper, button.firstChild);
    }
  });
}

function createAnimatedTextWrapper(text) {
  const wrapper = document.createElement('span');
  wrapper.className = 'text-wrapper';

  const textSpan1 = document.createElement('span');
  textSpan1.className = 'text';
  textSpan1.textContent = text;

  const textSpan2 = document.createElement('span');
  textSpan2.className = 'text';
  textSpan2.textContent = text;

  wrapper.appendChild(textSpan1);
  wrapper.appendChild(textSpan2);
  return wrapper;
}

document.addEventListener("DOMContentLoaded", () => {
  applyHoverEffects();

  // Observe changes in the filter sidebar
  const filterContainer = document.getElementById('main-collection-filters');

  if (filterContainer) {
    const observer = new MutationObserver(() => {
      applyHoverEffects();
    });

    observer.observe(filterContainer, { childList: true, subtree: true });
  }
});
